import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import './LanguageSelector.scss'

const LanguageSelector = ({ languageValue, handleChange }) => {
  return (
    <div className='language-selector'>
      <ToggleButtonGroup
        color='primary'
        value={languageValue}
        exclusive
        onChange={handleChange}
        aria-label='Language'
        size='small'
      >
        <ToggleButton value={'es'} sx={{ borderRadius: '4px' }}>
          ES
        </ToggleButton>
        <ToggleButton value={'en'} sx={{ borderRadius: '4px' }}>
          EN
        </ToggleButton>
        <ToggleButton value={'pt'} sx={{ borderRadius: '4px' }}>
          PT
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  )
}

export default LanguageSelector
